import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
import { styled } from "@mui/material/styles";
// @mui
import Slider, { SliderThumb } from "@mui/material/Slider";

RHFSlider.propTypes = {
  name: PropTypes.string,
};

const StyledSlider = styled(Slider)(({ theme }) => ({
  height: 3,
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 20,
    width: 20,
    backgroundColor: "#fff",
    border: "1px solid currentColor",
    "&:hover": {
      boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)",
    },
    "& .airbnb-bar": {
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-track": {
    height: 3,
  },
  "& .MuiSlider-rail": {
    color: "#bfbfbf",
    opacity: undefined,
    height: 3,
  },
  "& .MuiSlider-valueLabel": {
    fontSize: 12,
    fontWeight: 600,
    top: -2,
    backgroundColor: "unset",
    color: theme.palette.text.primary,
    "&:before": {
      display: "none",
    },
    "& *": {
      background: "transparent",
      color: "#000",
    },
  },
}));

function ThumbComponent(props) {
  const { children, ...other } = props;

  return <SliderThumb {...other}>{children}</SliderThumb>;
}

export default function RHFSlider({ name, rules, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => <StyledSlider {...field} components={{ Thumb: ThumbComponent }} {...other} />}
    />
  );
}
